import Styles from './Counter.module.scss'
import cx from 'classnames'

export enum CounterSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
}

export enum CounterVariant {
  Primary = 'primary',
  Grey = 'grey',
  Blue = 'blue',
}

interface Props {
  count: number
  label?: string
  className?: string
  plusIconClassName?: string
  size?: CounterSize
  variant?: CounterVariant
  noBorder?: boolean
}

const MAX = 99

export const Counter = ({
  count,
  label,
  className,
  plusIconClassName,
  size = CounterSize.md,
  variant = CounterVariant.Primary,
  noBorder = false,
}: Props) => {
  const displayCount =
    count > MAX ? (
      <>
        <span>{String(MAX)}</span>
        <span className={cx(Styles.plusIcon, plusIconClassName)}>+</span>
      </>
    ) : (
      <span>{String(count)}</span>
    )

  return (
    <div
      className={cx(Styles.dot, className, Styles[size], Styles[variant], {
        [Styles.noBorder]: noBorder,
        [Styles.withLabel]: !!label,
        [Styles.oneDigit]: count < 10,
        [Styles.twoDigit]: count >= 10 && count <= MAX,
        [Styles.max]: count > MAX,
      })}
    >
      {displayCount}
      {label && size !== CounterSize.xs && <span className={Styles.label}>{label}</span>}
    </div>
  )
}
